import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Link } from 'react-router-dom';
import { Card, CardBody } from 'reactstrap';

const ErrorNoAccessScreen = () => (
  <Card className="text-center">
    <CardBody className="p-5">
      <div className="display-1 text-200 fs-error">
        <FontAwesomeIcon icon="ban" />
      </div>
      <p className="lead mt-4 text-800 text-sans-serif font-weight-semi-bold">
        You don&apos;t have access to this page.
      </p>
      <hr />
      <p>
        Make sure the address is correct and that the page hasn&apos;t moved. If you think this is a mistake,
        <a href="mailto:info@exmaple.com" className="ml-1">
          contact us
        </a>
        .
      </p>
      <Link className="btn btn-primary btn-sm mt-3" to="/">
        <FontAwesomeIcon icon="home" className="mr-2" />
        Take me home
      </Link>
    </CardBody>
  </Card>
);

export default ErrorNoAccessScreen;
